export default __webpack_public_path__ + "static/media/Interest.4157b50a.svg";